const PostContent = ({ content }: { content: string }) => (
  <p className="text-tealGreen dark:text-primary mb-3">{content}</p>
);

export default PostContent;
